"use client";

import React from "react";
import { Accordion, AccordionItem } from "@heroui/accordion";

export default function Disclaimer({ disclaimer, companyName }) {
  const formatNumber = (number) => {
    const numberWords = {
      1: "one",
      2: "two",
      3: "three",
      4: "four",
      5: "five",
      6: "six",
      7: "seven",
      8: "eight",
      9: "nine",
      10: "ten",
    };

    return numberWords[number] || "Number out of range";
  };

  return (
    <Accordion className="mb-10" variant="bordered">
      <AccordionItem key="1" title="Disclaimer">
        <div className="disclaimer-page  mb-10">
          <h1 className="text-lg font-bold mb-4">
            Fundamental Research Corp. Equity Rating Scale:
          </h1>

          <section className="list-disc ml-5 mb-4">
            <ol>
              <li>
                <strong>Buy</strong> – Annual expected rate of return exceeding
                5%; the expected return is commensurate with risk
              </li>
              <li>
                <strong>Hold</strong> – Annual expected rate of return is
                between 5% and 12%
              </li>
              <li>
                <strong>Sell</strong> – Annual expected rate of return is below
                5% or the expected return is not commensurate with risk
              </li>
              <li>
                <strong>Suspended or Rating N/A</strong> – Coverage and ratings
                suspended until more information can be obtained from the
                company regarding recent events.
              </li>
            </ol>
          </section>

          <h1 className="text-lg font-bold mb-2">
            Fundamental Research Corp. – Risk Rating Scale:
          </h1>

          <ol className="list-decimal ml-5 mb-4">
            <li>
              <strong>(Low Risk)</strong> - The company operates in an industry
              where it has a strong position (for example a monopoly, high
              market share etc.) or operates in a regulated industry. The future
              outlook is stable or positive for the future. The company
              generates positive free cash flow and has a history of
              profitability. The capital structure is conservative with little
              or no debt.
            </li>
            <li>
              <strong> (Below Average Risk)</strong> - The company operates in
              an industry where the fundamentals and outlook are positive. The
              industry and company are relatively less sensitive to systemic
              risk than companies with a Risk Rating of 3. The company has a
              history of profitability and has demonstrated its ability to
              generate positive free cash flows (though current free cash flow
              may be negative due to capital investment). The company’s capital
              structure is conservative with little to modest use of debt.
            </li>
            <li>
              <strong> (Average Risk)</strong> - The company operates in an
              industry that has average sensitivity to systematic risk. The
              industry may be cyclical. Profits and cash flow are sensitive to
              economic factors although the company has demonstrated its ability
              to generate positive earnings and cash flow. Debt use is in line
              with industry averages, and coverage ratios are sufficient.
            </li>
            <li>
              <strong> (Speculative)</strong> - The company has little or no
              history of generating earnings or cash flow. Debt use is higher.
              These companies may be in start-up mode or in a turnaround
              situation. These companies should be considered speculative.
            </li>
            <li>
              <strong> (Highly Speculative)</strong> - The company has no
              history of generating earnings or cash flow. They may operate in a
              new industry with new, and unproven products. Products may be at
              the development stage, testing, or seeking regulatory approval.
              These companies may run into liquidity issues and may rely on
              external funding. These stocks are considered highly speculative.
            </li>
          </ol>

          <div className="mb-4">
            <h2 className="text-lg font-bold mb-2">
              Disclaimers and Disclosure
            </h2>
            <p className="mb-2">
              The opinions expressed in this report are the true opinions of the
              analyst about this company and industry. Any “forward looking
              statements” are our best estimates and opinions based upon
              information that is publicly available and that we believe to be
              correct, but we have not independently verified with respect to
              truth or correctness. There is no guarantee that our forecasts
              will materialize. Actual results will likely vary.
            </p>
            <p className="mb-2">
              Fundamental Research Corp. “FRC” owns shares of the subject
              company:{" "}
              <span className="font-bold">
                {disclaimer.frc_own ? "Yes" : "No"}.{" "}
              </span>
              The analyst owns shares of the subject company:{" "}
              <span className="font-bold">
                {disclaimer.frc_analyst_owns ? "Yes" : "No"}
              </span>{" "}
              , and does not make a market or offer shares for sale of the
              subject company, and does not have any investment banking business
              with the subject company.
            </p>

            <p className="mb-2">
              <strong>
                {" "}
                Fees have been paid to FRC by {companyName} to commission this
                report and research coverage including update reports . This fee
                creates a potential conflict of interest which readers should
                consider.{" "}
              </strong>{" "}
              The purpose of the fee is to subsidize the high costs of research
              and monitoring. FRC takes steps to ensure independence including
              setting fees in advance and utilizing analysts who must abide by
              CFA Institute Code of Ethics and Standards of Professional
              Conduct. Additionally, analysts may not trade in any security
              under coverage. Our full editorial control of all research, timing
              of release of the reports, and release of liability for negative
              reports are protected contractually. To further ensure
              independence, <strong>{companyName}</strong>
              has agreed to a minimum coverage term including an initial report
              and{" "}
              <span className="font-bold">
                {formatNumber(disclaimer.reports_amount)}{" "}
              </span>{" "}
              updates. Coverage cannot be unilaterally terminated. Distribution
              procedure: our reports are distributed first to our web-based
              subscribers on the date shown on this report then made available
              to delayed access users through various other channels for a
              limited time.
            </p>
            <p className="mb-2">
              The distribution of FRC&apos;s ratings are as follows:{" "}
              <span className="font-bold">
                BUY ({disclaimer.buy}%), HOLD ({disclaimer.hold}%), SELL /
                SUSPEND ({disclaimer.sell}%)
              </span>
              . {companyName}
            </p>
            <p className="mb-2">
              To subscribe for real-time access to research, visit
              <a className="text-blue-600 underline ml-2 mr-2" href="#">
                www.researchfrc.com/plans
              </a>
              for subscription options
            </p>
            <p className="mb-2">
              This report contains &quot;forward looking&quot; statements.
              Forward-looking statements regarding the Company and/or
              stock&apos;s performance inherently involve risks and
              uncertainties that could cause actual results to differ from such
              forward-looking statements. Factors that would cause or contribute
              to such differences include, but are not limited to, continued
              acceptance of the Company&apos;s products/technologies in the
              marketplace; acceptance in the marketplace of the Company&apos;s
              new product lines/services; competitive factors; new
              product/service introductions by others; technological changes;
              dependence on suppliers; systematic market risks which discuss
              discussed in the Company&apos;s periodic SEC filings, including
              interim reports, annual reports, and annual information forms
              filed with the various securities regulators. By making these
              forward-looking statements, Fundamental Research Corp. and the
              analyst/author of this report undertakes no obligation to update
              these statements for revisions or changes after the date of this
              report. A report initiating coverage will most often be updated
              quarterly while a report reconfirming a rating may have future
              results. A report initiating coverage will most often be updated
              quarterly while a report issuing a rating may have no further or
              less frequent updates because the subject company is likely to be
              in earlier stages where nothing material may occur quarter to
              quarter.
            </p>
            <p className="mb-2">
              Fundamental Research Corp DOES NOT MAKE ANY WARRANTY TO EXPRESS OR
              IMPLIED, AS TO RESULTS TO BE OBTAINED FROM USING THIS INFORMATION
              AND MAKES NO EXPRESS OR IMPLIED WARRANTIES OF FITNESS FOR A
              PARTICULAR USE. ANYONE USING THIS REPORT ASSUMES FULL
              RESPONSIBILITY FOR WHATEVER RESULTS THEY OBTAIN FROM WHATEVER USE
              THE INFORMATION WAS PUT TO. ALTERNATIVELY, TO COVER FINANCIAL
              ADVISOR BEFORE YOU INVEST. WHETHER A STOCK SHOULD BE INCLUDED IN A
              PORTFOLIO DEPENDS ON ONE&apos;S RISK TOLERANCE AND OTHER FACTORS,
              FULL DESCRIPTION OF THE ASSETS, ETC. ONLY YOUR INVESTMENT ADVISOR
              WHO KNOWS YOU UNIQUE CIRCUMSTANCES CAN MAKE A PROPER
              RECOMMENDATION AS TO THE MERIT OF ANY PARTICULAR SECURITY FOR
              INCLUSION IN YOUR PORTFOLIO. THIS REPORT IS SOLELY FOR INFORMATIVE
              PURPOSES AND IS NOT A SOLICITATION OF AN OFFER TO BUY OR SELL ANY
              SECURITY. IT IS NOT INTENDED AS INVESTMENT ADVICE OR OPINION FOR
              INDIVIDUAL INVESTOR OR INVESTMENT PURPOSES. It is not a
              solicitation for offers to buy or sell any securities. All
              statements in this report were independently prepared unless
              otherwise stated and HAVE NOT BEEN ENDORSED BY THE MANAGEMENT OF
              THE COMPANY WHICH IS THE SUBJECT OF THIS REPORT. Additional
              information is available upon request. THIS REPORT IS COPYRIGHT.
              YOU MAY NOT REDISTRIBUTE THIS REPORT WITHOUT OUR PERMISSION.
              Please give proper credit, including citing Fundamental Research
              Corp and/or the analyst, when quoting information from this
              report.
            </p>
            <p>
              The information contained in this report is intended to be viewed
              only in jurisdictions where it may be legally viewed and is not
              intended for use by any person or entity in any jurisdiction where
              such use would be contrary to local regulations or which would
              require any registration requirement within such jurisdiction.
            </p>
          </div>
        </div>
      </AccordionItem>
    </Accordion>
  );
}
